export default __webpack_public_path__ + "static/media/notification-blue.1fab8e0a.svg";